import { convertDetected } from './DriverDetected';
import { ValueBridge } from './ValueBridge';
export class DetectedBridge extends ValueBridge {
    constructor(state, control, channelsConfigName, controlInfo, powerState, transport, valueCallback, framework, log) {
        super(
        // old: configDetected, new: detected
        channelsConfigName ? 'configDetected' : 'detected', state, control, controlInfo, powerState, transport, valueCallback, log);
        this.channelsConfigName = channelsConfigName;
        this.framework = framework;
        if (control.recomputeCapsOnChange) {
            this.secondStateSubscription = this.state.subscribe((prev) => {
                if (this.framework.phase === 'controlling')
                    this.framework.recomputeCaps();
            }, false);
        }
        this.notifyInitialValuesIfUnhanged = true;
    }
    convertToParam(detected) {
        // This is the old way. DSPs would send an array of detected channels, and we convert them
        // to an object.
        if (Array.isArray(detected)) {
            const convertedChannels = {};
            let i = 0;
            for (const channel of detected) {
                convertedChannels[`a${i++}`] = channel;
            }
            return {
                path: this.channelsConfigName
                    ? [this.channelsConfigName, 'detected']
                    : ['detected'],
                detected: convertedChannels !== null && convertedChannels !== void 0 ? convertedChannels : detected,
            };
        }
        // This is the new method.
        return convertDetected(detected);
    }
    destroy() {
        if (this.secondStateSubscription !== undefined) {
            this.state.unsubscribe(this.secondStateSubscription);
        }
        super.destroy();
    }
}
